<template>
<v-app>
    <v-app-bar
      app
      color="primary"
      
      dense
    >
      <div style="color:white;" class="d-flex align-center font-weight-bold pl-2">
        Whitecastle Subproject Scheduler

      </div>
              <v-spacer></v-spacer>
              <div class="d-flex align-center mx-2">
                <label class="caption mr-2" style="color:white" >Included Departments</label>
         <v-autocomplete
            class="extra_padded_chips"
            v-model="selected_department"
            :items="departments"
            item-text="Department_Name"
            item-value="ID"
            hide-details
            chips
            small-chips

            label="Departments"
            multiple
            dense
            deletable-chips
           
            solo
            @blur="change_department_filter"
          ></v-autocomplete>
          </div>
    </v-app-bar>
    <v-main>
      <Main></Main>
    </v-main>
  </v-app>
</template>


<script>
import { mapState } from 'vuex'
// import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields';
import Main from './components/Main';
  export default {
    name: 'App',
    components:{
      Main
    },
    created(){
      let hash = this.$route.hash
      if (hash){
        var params = {}
        hash.split('#')[1].split('&').forEach(p=>{
          let components = p.split('=')
          if(components.length==2){
            params[components[0]] = components[1]
          }
        })
        console.log(params)
        this.access_token = params.access_token
        window.history.replaceState({}, document.title,'/');
        this.bootstrapApp()
      }
      else {
        this.authorize()
      }
    },
    computed: {
      ...mapState(['departments']),
       ...mapFields(['access_token','selected_department']),
    },
    methods: {
      ...mapActions(['authorize','bootstrapApp','getSchedule']),
      change_department_filter(){
        window.localStorage.setItem('wc_gantt_departments',JSON.stringify(this.selected_department));
        this.getSchedule()
      }
    }
  }
</script>


<style>

</style>
